export default "__VITE_ASSET__Cf3V3Fba__"